<template>
  <div>
    <header-title :Title="`云文档`"></header-title>
    <div style="height: 9.5rem; overflow-y: scroll">
      <el-card style="border-radius: 0.25rem">
        <div class="flex-between">
          <div class="tui-tabs">
            <div
              class="tui-tabsItem"
              @click="onClickTabList(index)"
              :class="currentIndex == index ? 'tui-active' : ''"
              v-for="(item, index) in tabList"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 新建文件 -->
          <div class="flex-items">
            <div
              class="tui-addCloud"
              @click="onClickDownAll"
              style="background: #fff; border: 1px solid #d9d9d9"
            >
              <i class="el-icon-download"></i>
              <div style="color: #333">批量下载</div>
            </div>
            <div
              class="tui-addCloud"
              v-if="currentIndex == 1"
              @click="onClickAddShare"
              style="background: #fff; border: 1px solid #d9d9d9"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804152147_9830.png"
                alt=""
              />
              <div style="color: #333">添加</div>
            </div>
            <div
              class="tui-addCloud"
              v-if="currentIndex == 2"
              @click="onClickAddShare"
              style="background: #fff; border: 1px solid #d9d9d9"
            >
              <i class="el-icon-circle-close"></i>
              <div style="color: #333">批量取消</div>
            </div>
            <div
              v-if="currentIndex == 0"
              class="tui-addCloud"
              style="background: #fff; border: 1px solid #d9d9d9"
              @click="onClickUpload('first')"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804152117_9073.png"
                alt=""
              />
              <div style="color: #333">大文件上传</div>
            </div>
            <div
              v-if="currentIndex == 0"
              class="tui-addCloud"
              style="background: #fff; border: 1px solid #d9d9d9"
              @click="onClickUploadAll('two')"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804152117_9073.png"
                alt=""
              />
              <div style="color: #333">上传</div>
            </div>
            <div
              class="tui-addCloud"
              @click="onClickAdd"
              v-if="currentIndex == 0"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804141844_0242.png"
                alt=""
              />
              <div>新建文件夹</div>
            </div>
          </div>
        </div>
        <!-- 默认文件夹 -->
        <div v-if="currentIndex == 0 && HX_FolderInfo.length != 0">
          <div class="tui-cloudStorage">默认文件夹</div>
          <div class="tui-cloudList">
            <div
              class="tui-cloudListItem"
              v-for="(item, index) in HX_FolderInfo"
              :key="index"
            >
              <div class="tui-cloudContent" @click="onClickDetail(item)">
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804143952_6872.png"
                  alt=""
                />
                <div>{{ item.FolderName }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 云盘 -->
        <div v-if="CustomHX_FolderInfo.length != 0">
          <div class="tui-cloudStorage">
            {{
              currentIndex == 0
                ? "自定义文件夹"
                : currentIndex == 1
                ? "共享文件夹"
                : "我的共享文件夹"
            }}
          </div>
          <div class="tui-cloudList">
            <div
              class="tui-cloudListItem"
              v-for="(item, index) in CustomHX_FolderInfo"
              :key="index"
            >
              <el-dropdown
                class="tui-cloudRight"
                v-if="currentIndex != 1"
                @command="handleCommand($event, item)"
              >
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804143709_5529.png"
                  alt=""
                />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="flex-items" command="refresh">
                    <i class="el-icon-edit-outline"></i>
                    <div>重命名</div>
                  </el-dropdown-item>
                  <el-dropdown-item class="flex-items" command="delete">
                    <i class="el-icon-delete"></i>
                    <div>{{ currentIndex == 2 ? "取消分享" : "删除" }}</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <div class="tui-cloudContent" @click="onClickDetail(item)">
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804143952_6872.png"
                  alt=""
                />
                <div>{{ item.FolderName }}</div>
              </div>
            </div>
          </div>
          <el-empty
            v-if="CustomHX_FolderInfo.length == 0"
            description="暂无数据"
          ></el-empty>
        </div>
        <!-- 文件列表 -->
        <el-table
          :data="FileInfoList"
          style="width: 100%"
          @selection-change="FileHandleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="文件名" align="center">
            <template slot-scope="scope">
              <div class="flex-items">
                <img :src="getImgData(scope.row.Suffix, scope.row)" alt="" />
                <div>{{ scope.row.FileName + "." + scope.row.Suffix }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="UserName" label="所属人" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="时间" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onClickFileName(scope.row)"
                v-if="currentIndex != 1"
                >重命名</el-button
              >
              <el-button
                type="text"
                v-if="currentIndex != 1"
                style="color: #fe706b"
                @click="DeleteHx_Cloud_FileInfo(scope.row)"
                >{{ currentIndex == 2 ? "取消共享" : "删除" }}</el-button
              >
              <el-button type="text" @click="onClickDownload(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="PageIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="text-align: center; padding: 20px 0 0 0"
        >
        </el-pagination>

        <el-empty
          v-if="FileInfoList.length == 0 && CustomHX_FolderInfo.length == 0"
          description="暂无数据"
        ></el-empty>
      </el-card>
    </div>
    <!-- 创建文件夹 -->
    <el-dialog :title="cloudTitle" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form ref="form" :model="form" label-position="top">
          <el-form-item label="文件夹名称:">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="onClickAddCloud"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 删除文件夹 -->
    <el-dialog title="" :visible.sync="dialogVisibleDelete" width="20%" center>
      <div class="tui-deleteCloud">
        <img
          src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804150425_1439.png"
          alt=""
        />
        <div>您确定要删除文件夹{{ form.name }}吗？删除后文件夹后不可恢复。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDelete = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="onClickDeleteCloud"
          >删 除</el-button
        >
      </span>
    </el-dialog>
    <!-- 上传 -->
    <el-dialog
      title="上传"
      :visible.sync="dialogVisibleImport"
      width="30%"
      center
    >
      <div class="flex-center">
        <el-upload
          :file-list="fileListArr"
          class="image-uploader"
          :auto-upload="true"
          ref="upload"
          :show-file-list="true"
          :drag="true"
          action
          :limit="1"
          :on-exceed="handleExceed"
          :before-upload="beforeUpload"
          :http-request="afterRead"
          :on-remove="handleRemoveFj"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            一次只能上传一个文件，单文件不超过1G
          </div>
        </el-upload>
      </div>

      <div
        class="loadingModal"
        :style="{ height: '100%' }"
        v-if="progressLoading"
      >
        <el-progress
          :stroke-width="20"
          :text-inside="true"
          :percentage="progress"
          :color="colors"
        ></el-progress>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="上传"
      :visible.sync="dialogVisibleImportAll"
      width="30%"
      center
    >
      <div class="flex-center">
        <el-upload
          :file-list="fileList"
          class="image-uploader"
          multiple
          :auto-upload="true"
          ref="upload"
          :show-file-list="true"
          :drag="true"
          action
          :limit="10"
          :before-upload="TwoBeforeUpload"
          :http-request="afterReadBatch"
          :on-remove="TwoHandleRemoveFj"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            上传多个文件，单文件不超过50M
          </div>
        </el-upload>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImportAll = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
    <!-- 重命名文件 -->
    <el-dialog title="重命名文件" :visible.sync="dialogVisibleFile" width="30%">
      <div>
        <el-form ref="form" :model="form" label-position="top">
          <el-form-item label="文件名称:">
            <el-input v-model="fileInfo.name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleFile = false" round>取 消</el-button>
        <el-button
          round
          type="primary"
          style="background: #27abf7"
          @click="UpdateHx_Cloud_FileInfo"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 共享文件 -->
    <el-dialog
      :title="
        currentIndex != 2 ? '添加以下文件至共享空间' : '取消以下文件至共享空间'
      "
      :visible.sync="dialogVisibleShare"
      width="50%"
      custom-class="tui-dialog"
    >
      <div>
        <el-table
          ref="multipleTable"
          :data="shareTableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column label="文件名称" align="center">
            <template slot-scope="scope">
              <div class="flex-items tui-tableImg">
                <img
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815175804_0237.png"
                  v-if="scope.row.Sort == 1"
                  alt=""
                />
                <img
                  :src="getImgData(scope.row.Suffix)"
                  v-if="scope.row.Sort != 1"
                  alt=""
                />
                <div style="padding-left: 10px">{{ scope.row.Name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="UserName" label="所有者" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="shareHandleSizeChange"
          @current-change="shareHandleCurrentChange"
          :current-page="shareIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="shareSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="shareTotal"
          style="text-align: center; padding: 20px 0 0 0"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleShare = false">取 消</el-button>
        <el-button type="primary" @click="onClickShareSubmit">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 重命名文件 -->
    <!-- <el-dialog
      title="重命名下载文件"
      :visible.sync="dialogVisibleDown"
      width="30%"
    >
      <el-input v-model="fileName" placeholder="请输入名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDown = false">取 消</el-button>
        <el-button type="primary" @click="onDownFile">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import headerTitle from "@/components/headerTitle/headerTitle.vue";
import OSS from "ali-oss";

import {
  GetHx_CloudInfo,
  CreateHx_Cloud_FolderInfo,
  UpdateHx_Cloud_FolderInfo,
  DeleteHx_Cloud_FolderInfo,
  GetHx_CloudFileInfo,
  UploadFilesPag,
  AddHx_Cloud_FileInfo,
  UpdateHx_Cloud_FileInfo,
  DeleteHx_Cloud_FileInfo,
  AddShareInfo,
  GetAllShareInfo,
  BatchAddHx_Cloud_FileInfo,
  UploadFileNewCloud,
} from "../../api/api";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      shop_name: "",
      tempUrl: "", //存上传后的图片url
      dataObj: {
        region: "oss-cn-shanghai", //我的存储是北京，可根据具体配置自行修改
        accessKeyId: "LTAI5tFV2gKH9MHbHip3UUFV",
        accessKeySecret: "bew7cr5TthXrrkQkHauZG10xuqKW8z",
        bucket: "mushroomisand",
      }, //存签名信息
      baseAli: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com", //我的存储是北京，可根据具体配置自行修改
      progress: 0, //进度条

      tabList: [
        {
          name: "我的空间",
          id: 0,
        },
        {
          name: "共享空间",
          id: 1,
        },
        {
          name: "我的共享",
          id: 2,
        },
      ],
      currentIndex: 0,
      dialogVisible: false,
      dialogVisibleFile: false,
      dialogVisibleDelete: false,
      dialogVisibleImport: false,
      dialogVisibleShare: false,
      dialogVisibleDown: false,
      form: {
        name: "",
        FolderId: 0,
      },
      userInfo: {},
      cloudTitle: "",
      CustomHX_FolderInfo: [],
      HX_FolderInfo: [], //默认文件夹
      excelurl: "",
      size: 0,
      excelName: "",
      FileInfoList: [],
      fileInfo: {
        name: "",
        Id: 0,
      },
      tableData: [],
      fileIds: [], //文件
      folderIds: [], //文件夹
      loading: false,
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      fileName: "",
      fileUrl: "",
      shareIndex: 1,
      shareSize: 20,
      shareTableData: [],
      shareTotal: 0,
      allDownList: [],
      progressLoading: false,
      percentage: 0,
      colors: "#32C5FF", //颜色自己规定
      numUpload: 1,
      fileListArr: [],
      firstPlayFlag: true, // 第一次播放标记
      blockNum: 0,
      uploading: false, // 是否正在上传文件
      activeName: "first",
      fileList: [],
      dialogVisibleImportAll: false,
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.GetHx_CloudInfo();
    this.GetHx_CloudFileInfo();
  },
  methods: {
    formatDate() {
      var value = new Date();
      var year = value.getFullYear();
      var month = formatNum(value.getMonth() + 1);
      var day = formatNum(value.getDate());
      return year + "/" + month + "/" + day;
    },
    formatNum(num) {
      return num < 10 ? "0" + num : num;
    },
    //分片上传
    afterRead(file) {
      this.progress = 0;
      var that = this;
      this.progressLoading = true;
      // 此时可以自行将文件上传至服务器
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const filename = file.file.name.substring(0, tmpcnt);
      var value = new Date();
      var year = value.getFullYear();
      var month = this.formatNum(value.getMonth() + 1);
      var day = this.formatNum(value.getDate());

      var time = year + "/" + month + "/" + day + "/";
      let client = new OSS(this.dataObj);

      const progress = (p, _checkpoint) => {
        // Object的上传进度。
        //console.log(p, "p");
        this.progress = Math.round(p * 100, 3);
        // 分片上传的断点信息。
        //console.log(_checkpoint, "_checkpoint");
      };
      // 开始分片上传。
      async function multipartUpload() {
        try {
          console.log(file.file, "file.file");
          //const fileName ="/aaaaaa/" + that.userInfo.uID + "/" + time + file.file.name;
          const fileName =
            "/NewCloud/resource/" +
            that.userInfo.uID +
            "/" +
            time +
            file.file.name;
          console.log(fileName, "fileName");
          // 依次填写Object完整路径（例如exampledir/exampleobject.txt）和本地文件的完整路径（例如D:\\localpath\\examplefile.txt）。Object完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径（例如examplefile.txt），则默认从示例程序所属项目对应本地路径中上传文件。
          const result = await client.multipartUpload(fileName, file.file, {
            progress,
            // 指定meta参数，自定义Object的元信息。通过head接口可以获取到Object的meta数据。
            meta: {
              year: year,
              people: "people",
            },
          });
          console.log(result, "result");
          if (result.res.statusCode == "200") {
            that.loading = false;
            that.fileListArr.push({
              name: filename,
              url: that.baseAli + result.name,
              size: file.file.size,
            });
            that.progressLoading = false;
            console.log(that.fileListArr, "  this.fileListArr");
          }
          // // 填写Object完整路径，例如exampledir/exampleobject.txt。Object完整路径中不能包含Bucket名称。
          // const head = await client.head(fileName);
          // console.log(head);
        } catch (e) {
          // 捕获超时异常。
          if (e.code === "ConnectionTimeoutError") {
            console.log("TimeoutError");
            // do ConnectionTimeoutError operation
          }
          console.log(e, "ccc");
        }
      }
      multipartUpload();
    },
    //批量上传
    afterReadBatch(file) {
      var that = this;
      //判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const filename = file.file.name.substring(0, tmpcnt);
      var value = new Date();
      var year = value.getFullYear();
      var month = this.formatNum(value.getMonth() + 1);
      var day = this.formatNum(value.getDate());
      var time = year + "/" + month + "/" + day + "/";
      let client = new OSS(this.dataObj);
      async function put() {
        try {
          const fileName =
            "/NewCloud/resource/" +
            that.userInfo.uID +
            "/" +
            time +
            file.file.name;
          // 填写OSS文件完整路径和本地文件的完整路径。OSS文件完整路径中不能包含Bucket名称。
          // 如果本地文件的完整路径中未指定本地路径，则默认从示例程序所属项目对应本地路径中上传文件。
          const result = await client.put(fileName, file.file);
          console.log(result, "result  ");
          if (result.res.statusCode == "200") {
            that.loading = false;
            that.fileList.push({
              name: filename,
              url: result.url,
              size: file.file.size,
            });
            that.progressLoading = false;
            console.log(that.fileList, "  this.fileList");
          }
        } catch (e) {
          console.log(e);
        }
      }

      put();
    },
    handleClick(tab, e) {
      console.log(tab, e);
      this.activeName = tab.name;
    },
    // 选择文件改变
    handleChange(files, fileList) {
      this.fileListArr = fileList;
    },
    getNum(val) {
      console.log((val / this.blockNum) * 100);
      return Number(((val / this.blockNum) * 100).toFixed());
    },
    start() {
      const that = this;
      that.$nextTick(() => {
        that.progressLoading = true;
        that.percentage = 0;
        that.timeStart = setInterval(() => {
          if (that.percentage < 95) {
            that.percentage += 1;
          }
        }, 100);
      });
    },
    // 进度条结束
    end() {
      const that = this;
      that.percentage = 100;
      clearInterval(this.timeStart);
      setTimeout(() => {
        that.progressLoading = false;
      }, 300);
    },
    // 选择的批量下载的数据
    FileHandleSelectionChange(e) {
      this.allDownList = e;
      console.log(e);
    },
    onClickDownAll() {
      if (this.allDownList.length != 0) {
        var blogTitle = `批量下载文件集合`; // 下载后压缩包的命名
        var zip = new JSZip();
        var promises = [];
        let cache = {};
        let arrImg = [];
        for (let i = 0; i < this.allDownList.length; i++) {
          arrImg.push({
            path: this.allDownList[i].FileUrl, // 文件链接
            name: this.allDownList[i].FileName, // 文件名称
          });
        }
        for (let item of arrImg) {
          // item.path为文件链接地址
          const promise = this.getImgArrayBuffer(item.path).then((data) => {
            // 下载文件, 并存成ArrayBuffer对象(blob)
            zip.file(item.name, data, { binary: true }); // 逐个添加文件
            cache[item.name] = data;
          });
          promises.push(promise);
        }
        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: "blob" }).then((content) => {
              // 生成二进制流
              FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  自定义文件名
            });
          })
          .catch((res) => {
            alert("文件压缩失败");
          });
      } else {
        this.$message({
          type: "error",
          message: "请选择批量下载的文件",
        });
      }
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.GetHx_CloudFileInfo();
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    //分页
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetHx_CloudFileInfo();
    },
    shareHandleSizeChange(e) {
      this.shareSize = e;
      this.GetAllShareInfo();
    },
    //分页
    shareHandleCurrentChange(val) {
      this.shareIndex = val;
      this.GetAllShareInfo();
    },
    // 处理文件名称
    getNameData(item) {
      let path2 = item.FileName.replace("." + item.Suffix, ""); //文件名称去掉路径和后缀名
      //console.log(path2, "aaaa");
      return path2;
    },
    onClickDetail(item) {
      //console.log(item);
      if (item.FolderName == "照片管理") {
        this.$router.push({
          path: "/cloud/student-index",
          query: {
            t: +new Date(), //保证每次点击路由的query项都是不一样的，确保会重新刷新view
          },
        });
      } else {
        this.$router.push({
          path: "/cloud-document/detail",
          query: {
            t: +new Date(), //保证每次点击路由的query项都是不一样的，确保会重新刷新view
            FolderId: item.FolderId,
            oldFolderId: 0,
            FolderName: item.FolderName,
            current: this.currentIndex,
          },
        });
      }
    },
    // 共享空间添加
    async onClickShareSubmit() {
      let res = await AddShareInfo({
        fileIds: this.fileIds.map((item) => item.Id),
        folderIds: this.folderIds.map((item) => item.Id),
        isShare: this.currentIndex == 2 ? 0 : 1,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: this.currentIndex == 2 ? "取消分享成功" : "添加共享成功",
        });
        this.GetHx_CloudInfo();
        this.GetHx_CloudFileInfo();
        this.dialogVisibleShare = false;
      } else {
        this.$message({
          type: "error",
          message: res.msg,
        });
      }
    },

    // 图片处理
    getImgData(e, item) {
      // let path1 = item.FileName.substr(item.FileName.lastIndexOf("/") + 1); //文件名称，去掉路径
      // let path2 = path1.substring(0, path1.indexOf(".")); //文件名称去掉路径和后缀名
      // //console.log(path1, path2, "aaa");
      // ;
      var ImgData = "";
      switch (e) {
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180305_5336.png"; //图片
          break;
        case "word":
        case "docx":
        case "doc":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180448_8795.png";
          break;
        case "excel":
        case "xls":
        case "xlsx":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180531_3975.png";
          break;
        case "ppt":
        case "pptx":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180549_5391.png";
          break;
        case "txt":
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180604_9937.png";
          break;
        default:
          ImgData =
            "http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-15/20220815180810_4622.png";
          break;
      }
      //console.log(ImgData);
      return ImgData;
    },
    handleSelectionChange(e) {
      this.folderIds = e.filter((item) => item.Sort == 1);
      this.fileIds = e.filter((item) => item.Sort != 1);
      //console.log(this.folderIds, this.fileIds);
    },
    // 共享文件
    async onClickAddShare() {
      this.shareIndex = 1;
      this.shareSize = 20;
      this.folderIds = [];
      this.fileIds = [];

      this.GetAllShareInfo();
      this.dialogVisibleShare = true;
    },
    async GetAllShareInfo() {
      let res = await GetAllShareInfo({
        IsShare: this.currentIndex == 2 ? 1 : 0,
        UserId: this.userInfo.uID,
        StudentId: 0,
        Name: "",
        PageIndex: this.shareIndex,
        PageSize: this.shareSize,
      });
      if (res.data.success) {
        this.shareTableData = res.data.response.data;
        this.shareTotal = res.data.response.dataCount;
      } else {
        this.shareTableData = [];
        this.shareTotal = 0;
      }
    },
    async DeleteHx_Cloud_FileInfo(item) {
      if (this.currentIndex == 2) {
        let res = await AddShareInfo({
          fileIds: [item.Id],
          folderIds: [],
          isShare: this.currentIndex == 2 ? 0 : 1,
        });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: this.currentIndex == 2 ? "取消分享成功" : "添加共享成功",
          });
          this.PageIndex = 1;
          this.GetHx_CloudInfo();
          this.GetHx_CloudFileInfo();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let res = await DeleteHx_Cloud_FileInfo({
            Id: item.FileId,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.PageIndex = 1;
            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              type: "error",
              message: "删除失败!",
            });
          }
        });
      }
    },
    onClickFileName(item) {
      this.fileInfo = {
        name: item.FileName,
        Id: item.FileId,
      };
      this.dialogVisibleFile = true;
    },
    // 重命名文件
    async UpdateHx_Cloud_FileInfo() {
      let res = await UpdateHx_Cloud_FileInfo(this.fileInfo);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "重命名文件成功",
        });
        this.dialogVisibleFile = false;
        this.GetHx_CloudInfo();
        this.GetHx_CloudFileInfo();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },

    onClickDownload(item) {
      this.fileUrl = item.FileUrl;
      var fileName = item.FileName.replace("." + item.Suffix, " "); //文件名称去掉路径和后缀名
      if (fileName != "") {
        this.getBlob(this.fileUrl).then((blob) => {
          this.saveAs(blob, fileName);
          this.dialogVisibleDown = false;
        });
      } else {
        this.$message({
          type: "warning",
          message: "请填写名称内容",
        });
      }
    },
    //下载文件 　　js模拟点击a标签进行下载
    saveAs(blob, filename) {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    //通过文件下载url拿到对应的blob对象
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    async GetHx_CloudFileInfo() {
      let res = await GetHx_CloudFileInfo({
        Type: this.currentIndex + 1,
        UserId: this.userInfo.uID,
        StudentId: 0,
        ParentId: 0,
        Name: "",
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      });
      if (res.data.success) {
        this.FileInfoList = res.data.response.data.map((cc) => {
          return {
            CreateTime: cc.CreateTime,
            FileId: cc.FileId,
            FileName: cc.FileName,
            FileType: cc.Suffix,
            FileUrl: cc.FileUrl,
            UpdateTime: cc.UpdateTime,
            UserName: cc.UserName,
            Suffix: cc.Suffix,
            Sort: cc.Sort,
          };
        });
        this.total = res.data.response.dataCount;
        //console.log(this.FileInfoList, " this.FileInfoList");
      } else {
        this.FileInfoList = [];
      }
    },
    // 删除文件夹
    async onClickDeleteCloud() {
      let res = await DeleteHx_Cloud_FolderInfo({
        Id: this.form.FolderId,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: "删除文件夹成功",
        });
        this.dialogVisibleDelete = false;
        this.form.name = "";
        this.PageIndex = 1;
        this.form.FolderId = 0;
        this.GetHx_CloudInfo();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    // 获取我的文件夹
    async GetHx_CloudInfo() {
      let res = await GetHx_CloudInfo({
        Type: this.currentIndex + 1,
        UserId: this.userInfo.uID,
        StudentId: 0,
        ParentId: 0,
        Name: "",
      });
      if (res.data.success) {
        this.CustomHX_FolderInfo = res.data.response.CustomHX_FolderInfo;
        this.HX_FolderInfo = res.data.response.HX_FolderInfo;
      } else {
        this.CustomHX_FolderInfo = [];
        this.HX_FolderInfo = [];
      }
    },
    // 创建文件夹
    async onClickAddCloud() {
      if (this.form.name != "") {
        if (this.cloudTitle == "创建文件夹") {
          let res = await CreateHx_Cloud_FolderInfo({
            name: this.form.name,
            parentId: 0,
            UserId: this.userInfo.uID,
            isShare: this.currentIndex == 0 ? 0 : 1,
            StudentId: 0,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "新增文件夹成功",
            });
            this.dialogVisible = false;
            this.form.name = "";
            this.GetHx_CloudInfo();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          let res = await UpdateHx_Cloud_FolderInfo({
            name: this.form.name,
            id: this.form.FolderId,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "重命名成功",
            });
            this.form.name = "";
            this.form.FolderId = 0;
            this.dialogVisible = false;
            this.GetHx_CloudInfo();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        }
      } else {
        this.$message({
          type: "error",
          message: "文件夹名称不能为空",
        });
      }
    },
    // 上传
    addCommand(e) {},
    // 删除文件夹
    async handleCommand(e, item) {
      //console.log(e, item);
      if (e == "delete") {
        if (this.currentIndex == 2) {
          let res = await AddShareInfo({
            fileIds: [],
            folderIds: [item.Id],
            isShare: this.currentIndex == 2 ? 0 : 1,
          });
          if (res.data.success) {
            this.$message({
              type: "success",
              message: this.currentIndex == 2 ? "取消分享成功" : "添加共享成功",
            });
            this.PageIndex = 1;
            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          this.dialogVisibleDelete = true;
          this.form.FolderId = item.FolderId;
          this.form.name = item.FolderName;
        }
      } else {
        //console.log(item, "aaaaaaaaa");
        this.cloudTitle = "重命名文件夹";
        this.form.FolderId = item.FolderId;
        this.form.name = item.FolderName;

        this.dialogVisible = true;
      }
    },
    onClickAdd() {
      this.cloudTitle = "创建文件夹";
      this.dialogVisible = true;
    },
    onClickTabList(index) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.currentIndex = index;
      this.GetHx_CloudInfo();
      this.GetHx_CloudFileInfo();
      loading.close();
    },
    //上传文件
    async ImportStudent() {
      console.log(this.fileListArr, "fileListArr");

      if (this.activeName == "first") {
        if (this.fileListArr.length == 0) {
          this.$message({
            message: "请选择文件",
            type: "error",
          });
        } else {
          let list = this.fileListArr.map((cc) => {
            return {
              hx_Cloud_FileName: cc.name,
              hx_Cloud_FileUrl: cc.url,
              storage: cc.size,
            };
          });
          let res = await BatchAddHx_Cloud_FileInfo({
            hx_FolderId: this.currentIndex == 0 ? 0 : this.hx_FolderId,
            UserId: this.userInfo.uID,
            isShare: this.currentIndex == 0 ? 0 : 1,
            StudentId: 0,
            list: this.activeName == "first" ? list : this.fileList,
          });
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            this.$refs.upload.clearFiles();
            //初始化数据
            this.dialogVisibleImport = false;
            this.dialogVisibleImportAll = false;

            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      } else {
        if (this.fileList.length == 0) {
          this.$message({
            message: "请选择文件",
            type: "error",
          });
        } else {
          let list = this.fileList.map((cc) => {
            return {
              hx_Cloud_FileName: cc.name,
              hx_Cloud_FileUrl: cc.url,
              storage: cc.size,
            };
          });
          let res = await BatchAddHx_Cloud_FileInfo({
            hx_FolderId: this.currentIndex == 0 ? 0 : this.hx_FolderId,
            UserId: this.userInfo.uID,
            isShare: this.currentIndex == 0 ? 0 : 1,
            StudentId: 0,
            list: list,
          });
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            this.$refs.upload.clearFiles();
            //初始化数据
            this.dialogVisibleImport = false;
            this.dialogVisibleImportAll = false;

            this.GetHx_CloudInfo();
            this.GetHx_CloudFileInfo();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        }
      }
    },
    //导入
    uploadFile(item) {
      // this.loading = true;
      if (this.firstPlayFlag) {
        this.progressLoading = true;
        this.firstPlayFlag = false;
      } else {
      }

      let that = this;
      console.log(this.numUpload, "uploadFile");
      var num = this.numUpload;
      this.progressPercent = num;

      const fileObj = item;
      // FormData 对象
      var file = item.file;
      const formData = new FormData();
      var time = new Date().getTime();
      //没文件为5m
      // 每片文件大小为5M
      var blockSize = 10 * 1024 * 1024;
      var blockNum = Math.ceil(file.size / blockSize);
      this.blockNum = blockNum;
      var nextSize = Math.min(num * blockSize, file.size);
      var fileData = file.slice((num - 1) * blockSize, nextSize);
      console.log(item, "fileData");
      formData.append("file", fileData);
      // 文件名
      formData.append("name", file.name);
      // 总片数
      formData.append("chunks", blockNum);
      formData.append("chunk", num);
      formData.append("md5", time);
      formData.append("uid", "13570");
      console.log(num, blockNum, "blockNum****************");
      UploadFilesPag(formData).then((response) => {
        console.log(response.data, "response.data.success");
        if (response.data.response) {
          this.numUpload = 1;
          console.log(fileObj, "fileObj");
          console.log(this, that, "this,that,uploadFile");
          this.excelurl = response.data.response;
          this.fileListArr.push({
            name: fileObj.file.name,
            url: response.data.response,
            size: fileObj.file.size,
          });
          this.excelName = fileObj.file.name;
          this.size = fileObj.file.size;
          // this.end();
          this.progressLoading = false;

          // console.log("filename", this.addForm.ContentUrl);
          this.$message.info("文件：" + item.file.name + "上传成功");

          // this.end();
        } else {
          console.log("递归");
          this.numUpload++;
          this.uploadFile(fileObj);
        }
      });
    },
    TwoUploadFile(item) {
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      UploadFileNewCloud(form).then((res) => {
        //console.log(res, fileObj);
        this.loading = false;
        this.fileList.push({
          name: fileObj.name,
          url: res.data.response,
          size: fileObj.size,
        });

        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    TwoHandleRemoveFj(file, fileList) {
      this.fileList = fileList;
    },
    handleRemoveFj(file, fileList) {
      // console.log(file, fileList);
      // let index = this.fileListArr.findIndex((item) => item.name == file.name);
      // console.log(index, "aaaaaaaaa");
      // this.fileListArr.splice(index, 1);
      this.fileListArr = fileList;
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
      const is10M = file.size / 1024 / 1024 < 1024;

      //限制文件上传大小
      if (!is10M) {
        this.$message.error("上传图片大小不能超过 1G!");
        return false;
      }

      return true;
      // return isText | isTextComputer;
    },
    TwoBeforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
      const is10M = file.size / 1024 / 1024 < 50;

      //限制文件上传大小
      if (!is10M) {
        this.$message.error("上传图片大小不能超过 50M!");
        return false;
      }

      return true;
      // return isText | isTextComputer;
    },
    onClickUpload(type) {
      this.activeName = type;

      this.fileListArr = [];
      this.fileList = [];
      this.excelurl = "";
      this.excelName = "";
      // this.$refs.upload.clearFiles();
      //console.log(this.$refs.upload, "hgfhfhgf");
      this.dialogVisibleImport = true;
    },
    onClickUploadAll(type) {
      this.activeName = type;

      this.fileListArr = [];
      this.fileList = [];
      this.excelurl = "";
      this.excelName = "";
      // this.$refs.upload.clearFiles();
      //console.log(this.$refs.upload, "hgfhfhgf");
      this.dialogVisibleImportAll = true;
    },
  },
};
</script>
<style lang="less">
.loadingModal {
  width: 100%;
  margin: 20px auto;
}
.tui-tableImg {
  img {
    width: 40px;
    height: 40px;
  }
}
.tui-pillar {
  width: 0.075rem;
  height: 0.3rem;
  background: #27abf7;
  border-radius: 3px;
}
.tui-headerTitle {
  font-size: 0.3rem;
  color: #333;
  font-weight: 600;
  padding-left: 0.125rem;
}
.el-dialog__header {
  background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-8/20220808145755_3530.png")
    no-repeat;
  padding: 30px 20px 30px;
  background-size: 100% 100%;
}
.tui-dialog {
  border-radius: 0.25rem;
  overflow: hidden;
}
.tui-feishu {
  display: flex;
  flex-direction: column;
  .tui-feishuItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.2rem 0;
    box-sizing: border-box;
    border-top: 1px solid #eee;
    cursor: pointer;
    img {
      width: 0.5rem;
      height: 0.5rem;
    }
    div {
      font-size: 0.25rem;
      padding-left: 0.25rem;
    }
  }
}
.tui-deleteCloud {
  display: flex;
  align-items: center;
  flex-direction: column;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
  div {
    width: 3.625rem;
    font-size: 0.225rem;
    color: #333;
    padding-top: 0.375rem;
    line-height: 0.25rem;
  }
}
.tui-cloudStorage {
  font-size: 0.25rem;
  color: #333;
  font-weight: 600;
  padding: 0.375rem 0 0.25rem 0;
}
.tui-cloudList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  .tui-cloudListItem:nth-of-type(5n) {
    margin-right: 0;
  }
  .tui-cloudListItem:hover {
    border: 1px solid #32c5ff;
  }
  .tui-cloudListItem {
    width: 3.55rem;
    height: 1.25rem;
    border-radius: 0.25rem;
    border: 1px solid #e9e9e9;
    position: relative;
    margin-right: 0.25rem;
    margin-bottom: 0.25rem;
    cursor: pointer;
    .tui-cloudRight {
      position: absolute;
      right: 0.15rem;
      top: 0.15rem;
      width: 0.2875rem;
      height: 0.2875rem;
      cursor: pointer;
    }
    .tui-cloudContent {
      padding: 0.3125rem 0 0 0.35rem;
      display: flex;
      align-items: center;
      img {
        width: 0.625rem;
        height: 0.625rem;
      }
      div {
        width: 1.875rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        font-size: 0.225rem;
        color: #333;
        padding-left: 0.1625rem;
      }
    }
  }
}
.tui-addCloud {
  width: 1.75rem;
  height: 0.5rem;
  background: #27abf7;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.25rem;
  cursor: pointer;
  img {
    width: 0.2rem;
    height: 0.2rem;
  }
  div {
    color: #fff;
    font-size: 0.2rem;
    padding-left: 0.0625rem;
  }
}
.tui-tabs {
  // width: 3.2625rem;
  height: 0.5rem;
  background: #f6f6f6;
  border-radius: 0.25rem;
  color: #333;
  font-size: 0.2rem;
  display: flex;
  align-items: center;

  .tui-tabsItem {
    width: 1.7125rem;
    height: 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.2rem;
  }
  .tui-active {
    background: #27abf7 !important;
    color: #fff !important;
  }
}
</style>